/**
 * Strip "sign" phrasing from user-facing copy when the org does not use
 * DocuSign TRF e-signature. DocuSign-enabled orgs keep the input unchanged.
 *
 * Covers the two shapes we ship: "Complete & Sign Order" / "Create & Sign Order"
 * and "Ready to complete and sign".
 */
export function copyWithoutSigning(text: string, docusignEnabled: boolean): string {
  if (docusignEnabled === true) return text
  return text
    .replace(/\s*&\s*Sign\b/gi, '')
    .replace(/\s+and sign\b/gi, '')
    .replace(/\s{2,}/g, ' ')
    .trim()
}
